import { render, staticRenderFns } from "./AffectUserToAgencyForm.vue?vue&type=template&id=9cc5d6f2&"
import script from "./AffectUserToAgencyForm.vue?vue&type=script&lang=js&"
export * from "./AffectUserToAgencyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports